// When the SPA last heard back from the BFF (ticket #67).
//
// This is the gate for the session watcher, and it is deliberately keyed on
// SERVER contact rather than on user input. What kills a session is the absence
// of requests, not the absence of clicks: Keycloak's idle clock is reset only by
// a token refresh, which the BFF performs lazily on an inbound request. A user
// who reads cached content for half an hour is continuously "active" and still
// loses the session, so an input-gap gate would never fire for them.
//
// Only successful responses count. A transport failure means we did not hear
// from the server, and treating it as contact would suppress the check exactly
// when connectivity has been interrupted.

let lastContactAt = Date.now();

export function markServerContact(): void {
  lastContactAt = Date.now();
}

// Infinity when the wall clock has moved backwards (NTP correction, timezone
// change, suspend/resume). An unusable delta must probe, never skip.
export function msSinceServerContact(): number {
  const delta = Date.now() - lastContactAt;
  return delta >= 0 ? delta : Number.POSITIVE_INFINITY;
}

export function resetServerContactForTest(at: number = Date.now()): void {
  lastContactAt = at;
}
